/* FluidContainer.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _14 = "._p12f16ka{max-width:77rem}";
const _13 = "._vchhusvi{box-sizing:border-box}";
const _12 = "._1bsbsz3t{width:calc(100% - 4rem)}";
const _11 = "._18u01wug{margin-left:auto}";
const _10 = "._otyridpf{margin-bottom:0}";
const _9 = "._2hwx1wug{margin-right:auto}";
const _8 = "._19pkidpf{margin-top:0}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives/responsive';
import { useSource } from '@atlassian/mpac-utils';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _7 = "@media screen and (min-width:120rem){._10zuidpf{margin-top:0}._11jr1wug{margin-right:auto}._1mxjidpf{margin-bottom:0}._5dk01wug{margin-left:auto}._1t461jt6{max-width:96rem}}";
const _6 = "@media (min-width:110.5rem){._1oyyidpf{margin-top:0}._1nyg31sa{margin-right:12rem}._1q0widpf{margin-bottom:0}._1wfm31sa{margin-left:12rem}}";
const _5 = "@media (min-width:90rem){._1b2sidpf{margin-top:0}._2dx01jdh{margin-right:9rem}._nkieidpf{margin-bottom:0}._1yoq1jdh{margin-left:9rem}}";
const _4 = "@media (min-width:64rem){._ue5g1408{margin:0 var(--ds-space-800,4pc)}}";
const _3 = "@media (min-width:48rem){._33c5zdiv{margin:0 var(--ds-space-500,40px)}}";
const _2 = "@media (min-width:30rem){._1letfkly{margin:0 var(--ds-space-400,2pc)}}";
const _ = "._18s81e2i{margin:0 var(--ds-space-300,24px)}";
export const MPACFluidContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_18s81e2i _1letfkly _33c5zdiv _ue5g1408 _1b2sidpf _2dx01jdh _nkieidpf _1yoq1jdh _1oyyidpf _1nyg31sa _1q0widpf _1wfm31sa _10zuidpf _11jr1wug _1mxjidpf _5dk01wug _1t461jt6", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  MPACFluidContainer.displayName = 'MPACFluidContainer';
}
export const EMCEEFluidContainer = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_8, _9, _10, _11, _12, _13, _14]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf _2hwx1wug _otyridpf _18u01wug _1bsbsz3t _vchhusvi _p12f16ka", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  EMCEEFluidContainer.displayName = 'EMCEEFluidContainer';
}
export const FluidContainer = _ref3 => {
  let {
    children,
    className,
    style
  } = _ref3;
  const source = useSource();
  const Container = source === 'MPAC' ? MPACFluidContainer : EMCEEFluidContainer;
  const testId = source === 'MPAC' ? 'mpac-fluid-container' : 'emcee-fluid-container';
  return /*#__PURE__*/_jsx(Container, {
    "data-testid": testId,
    className: className,
    style: style,
    children: children
  });
};